import React, { useCallback, useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import WriterModal from '../components/WriterModal';
import docUpadate from '../docUpdate';
import {useLocation } from "react-router-dom";
import PromptGetter from '../components/PromptGetter';
import MotivationSeeker from '../components/MotivationSeeker';
import InspirationSeeker from '../components/InspirationSeeker'
import docGetter from '../docListGetter';
import getCookie from '../getCookie';

const WritingArea = () => {
  const location = useLocation();
  const { existingContent } = location.state || {};
  const [minutes, setMinutes] = useState(localStorage.getItem('time'));
  const [seconds, setSeconds] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(true);  
  const [isPalVisible, setIsPalVisible]= useState(false);
  const [quill, setQuill] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [promptDisplay, setPromptDisplay] = useState(false);
  const [motivationDisplay, setMotivationDisplay] = useState(false);
  const [inspirationDisplay, setInspriationDisplay] = useState(false);
  const [saveIntervalId, setSaveIntervalId] = useState(null);
  const navigate = useNavigate();
//checking authntication
useEffect(() => {
  const checkAuthentication = async () => {
    const isAuthenticated = getCookie("auth-cookie");
    
    if (!isAuthenticated) {
      // Navigate to login if not authenticated
      navigate("/login");
    }
  };

  checkAuthentication();
}, []);
//setting wrapper
const wrapperRef = useCallback(async(wrapper)=>{
if(wrapper == null) return;
wrapper.innerHTML = ''
const editor  = document.createElement("div");
wrapper.append(editor);
const newQuill = new Quill(editor,{theme: "snow", modules: {toolbar:TOOLBAR_OPTIONS}});
setQuill(newQuill);
const loadedContent = await loadContent(); 

if (loadedContent.content!=='' && newQuill.clipboard) {
    
    const deltaJson = JSON.parse(loadedContent.content);
    
    const delta = new Delta(deltaJson['ops']);
    
    newQuill.setContents(delta);
    
}else{
  newQuill.setContents({
    ops: [
      { insert: loadedContent.title },
      { insert: '\n', attributes: { header: 1, align:'center'}},
      {insert:'Try typing these commands for added support: \n /\u200Cprompt \n /\u200Cfocus \n /\u200Cmotivate (beta) \n /\u200Cinspire (beta)\n Happy Writing!'} 
    ]
  }); 
}
},[]) 

const loadContent = async()=>{
   
   if(existingContent){
    
    const response = await docGetter('getDoc',existingContent.docRef);
    
    const jsonParsedData = await JSON.parse(response.response);
    
    return jsonParsedData;
   }
}

  useEffect(() => {
    const saveContent = async() => {
      // Replace the following line with the actual save logic
      
      if(quill !== null && quill.getContents){
        let title = quill.getText(0, quill.getLength()).split('\n')[0];
       
        
        
        let savedResponse = await docUpadate("save", existingContent.docRef ,title, JSON.stringify(quill.getContents()));
        
        
      }
    };

    // Start the interval when the component mounts
    const intervalId = setInterval(saveContent, 10000);
    setSaveIntervalId(intervalId);

    // Clean up the interval when the component unmounts
    return () => {
      if (saveIntervalId) {
        clearInterval(saveIntervalId);
      }
    };
  }, [quill]);
 
  useEffect(()=>{
    const startCountdown = () => {
      if(!modalIsOpen){
     
      if (!isNaN(minutes) && minutes > 0) {
        let totalSeconds = minutes * 60;
        const id = setInterval(() => {
          if (totalSeconds <= 0) {
            const timerDisplay = document.getElementById('timer-display');
            timerDisplay.innerHTML = "Yay! you wrote for your time";
            clearInterval(id);
          } else {
            const mins = Math.floor(totalSeconds / 60);
            const secs = totalSeconds % 60;
            setMinutes(mins);
            setSeconds(secs);
            totalSeconds -= 1;
          }
        }, 1000);
        // Set intervalId using setIntervalId
        
      }
    }
  };
   
    startCountdown();
  
   }, [modalIsOpen])
  
 
  
  //listening to fullscreenchanges
  useEffect((event) => {
    
    const handleFullScreenChange = (event) => {
      if(!document.fullscreenElement)
      {
        setIsFullScreen(false);
      }
    };

    window.addEventListener('fullscreenchange', handleFullScreenChange);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
  }, []);

  useEffect(() => {
    const handleKeyPress = async(event) => {
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault(); // Prevent the browser's default save action
        if(quill !== null && quill.getContents){
          let title = quill.getText(0, quill.getLength()).split('\n')[0];
          let savedResponse = await docUpadate("save", existingContent.docRef ,title, JSON.stringify(quill.getContents()));
          
        }// Call your save function here
      }
      if(quill.getText().includes("/prompt")){
        setIsPalVisible(true);
        setMotivationDisplay(false);
        setInspriationDisplay(false);
        setPromptDisplay(true);
        removeCommandFromQuill("/prompt");
        return;
      }
      
      if(quill.getText().includes("/motivate")){
        setIsPalVisible(true);
        setPromptDisplay(false);
        setInspriationDisplay(false);
        setMotivationDisplay(true);
        removeCommandFromQuill("/motivate");
        return;
      }
      if(quill.getText().includes("/inspire")){
        setIsPalVisible(true);
        setPromptDisplay(false);
        setMotivationDisplay(false);
        setInspriationDisplay(true);
        removeCommandFromQuill("/inspire");
        return;
      }
      if(quill.getText().includes("/focus")){
        setIsPalVisible(false);
        handlefocusMode();
        removeCommandFromQuill("/focus");
        return;
      }
    };

    // Add keypress event listener to the document
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [quill]);
  
 

  
  //looking for text change
  
  const TOOLBAR_OPTIONS = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ align: [] }],
    ["clean"]
  ]
  var Delta = Quill.import('delta')


  const handleCloseMotivationSeeker = () => {
    setIsPalVisible(false);}
  
  
  const removeCommandFromQuill = (command) => {
      const index = quill.getText().indexOf(command);
      if (index !== -1) {
        quill.deleteText(index, command.length);
      }
    };

  



  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
      setModalIsOpen(false);
  };
 


const handlefocusMode = () =>{

  if(document.documentElement.requestFullscreen){
    document.documentElement.requestFullscreen(); 
    setIsFullScreen(true)
  }
   
 
}



return (
  <div id = "writing-area">
     <WriterModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
     />
      
    {promptDisplay && <PromptGetter
    onClose={handleCloseMotivationSeeker}
    isVisible = {isPalVisible}/> }
    {motivationDisplay && <MotivationSeeker
    onClose={handleCloseMotivationSeeker}
    isVisible = {isPalVisible}
    />}
    {inspirationDisplay && <InspirationSeeker
    onClose={handleCloseMotivationSeeker}
    isVisible = {isPalVisible}
    />}
   
    <div id = "writing-container" 
      ref = {wrapperRef} 
      style={{ width: isPalVisible ? '70%' : '100%' }}
    >
    
    </div>
    <div id='timer-display'
      style={{ display: isPalVisible ? 'none' : 'block' }}>
        You are on the clock: {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </div> 
  </div>
    
  );
};

export default WritingArea;
